import type { ResetPasswordResponse } from '@weft/api-definition';
import { ResetPasswordResponseSchema, type ResetPasswordRequestPayload } from '@weft/api-definition';
import { ResponseError } from 'libs/client/src/generated';
import { useMutation, type UseMutationOptions } from 'react-query';
import { getPublicApi } from '../../services/api';

export function useRequestPasswordReset(options?: UseMutationOptions<ResetPasswordResponse, unknown, ResetPasswordRequestPayload>) {
  return useMutation({
    mutationFn: async ({ email }) => {
      try {
        const api = getPublicApi();
        const resetPasswordResponse = await api.resetPassword({ resetPasswordRequest: { email } });
        
        return ResetPasswordResponseSchema.parse( resetPasswordResponse);
      } catch (error) {
        const errorResponse = await handleResponseError(error);
        throw new Error(errorResponse);
      }
    },
    ...options,
  });
}

export async function handleResponseError(error: unknown) {
  if (error instanceof ResponseError) {
    const errorResponse = await error.response.json();

    return errorResponse.message;
  }

  return 'Unknown error';
}